export const environment = {
    production: true,
    apiBaseUrl: 'https://bonanza4all.com/api/',
    defaultTenant: 'bonanza-travel'
};



// WEBPACK FOOTER //
// ./src/environments/environment.ts